import * as React from 'react';
import * as styles from "./Element.css";
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from './../../stores';
import { Helper } from '../../../../Helper';
import { IAIcon } from '../../../icon/Icon';
import { Environment } from '../../../../services/Environment';
import { LoggingService } from '../../../../services/LoggingService';
import "../../../../styles/BasicIA.css";
import { IAConditionalTooltipWrapper } from '../../../tooltip/ConditionalTooltipWrapper';
import { IAReader } from '../../../reader/Reader';
import { NavigatorTargetingTooltip } from '../targetingTooltip/TargetingTooltop';
const IMG_STREAM = require("../../../../images/stream-large.png");
export interface IElementProps {
  navigatorStore?: NavigatorStore;
  type: string;
  config: any;
  topItemIndex: number;
  columnIndex: number;
  elementGroupIndex: number;
  index: number;
  width: number;
}

@inject('navigatorStore')
@observer
export class Element extends React.Component<IElementProps> {
  private readonly constructorName = "NavigatorElement";

  private getTargetingGroups(seperator?: string): string {
    return this.props.navigatorStore.GetUserGroupTargetingForNavigatorAnalytics(this.props.navigatorStore.navigator.megamenu.topItems[this.props.topItemIndex].elementGroups[
      this.props.columnIndex][this.props.elementGroupIndex].elements[this.props.index].targeting,
      this.props.navigatorStore.applicationSettings?.applicationSettings, seperator);
  }

  private onClick(trackingType: string) {
    if (!(this.props.navigatorStore.isMobile && (this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally))) {
      if (!this.props.navigatorStore.isInEditMode) {
        if (!!this.props.config.url) {
          LoggingService.trackEvent(this.constructorName, {
            ActionType: "LinkClick",
            Type: trackingType,
            Targeting: this.getTargetingGroups(),
            Title: !this.props.config.text ? this.props.config.url : this.props.config.text,
            ItemId: this.props.index,
            ElementGroupId: this.props.elementGroupIndex,
            ColumnId: this.props.columnIndex,
            TopItemId: this.props.topItemIndex,
            ItemType: "Element",
            Url: this.props.config.url,
            Tenant: this.props.navigatorStore.tenant,
            Instance: this.props.navigatorStore.instance,
            UserId: this.props.navigatorStore.token,
            Version: this.props.navigatorStore.navigator.version.id,
            PageUrl: window.location.pathname.toLowerCase(),
            SiteName: Helper.getSiteCollectionFromPath(window.location.pathname)?.toLowerCase() ?? "none",
          });
          if (!(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally)) {
            this.props.navigatorStore.isShowingMegamenu = false;
          }
        }
      } else {
        if (!this.props.navigatorStore.isShowingAnalytics && !this.props.navigatorStore.checkedOut) {
          this.props.navigatorStore.toggleElementSettings(this.props.topItemIndex, this.props.columnIndex, this.props.elementGroupIndex, this.props.index);
        }
      }
    }
  }

  render() {
    let iconSize: number = 20;
    let titleWidth: number = this.props.width;
    if (this.props.navigatorStore.isInEditMode) {
      titleWidth = titleWidth - 30;
      if (this.props.config.icon != null && this.props.config.icon != "") {
        titleWidth = titleWidth - iconSize;
      } else {
        if (this.props.navigatorStore.navigator.design.elements.indentation != undefined) {
          titleWidth = titleWidth - parseInt(this.props.navigatorStore.navigator.design.elements.indentation);
        }
      }
    } else {
      if (this.props.config.icon != null && this.props.config.icon != "") {
        titleWidth = titleWidth - iconSize - 20;
        if (this.props.navigatorStore.navigator.design.elements.indentation != undefined) {
          titleWidth = titleWidth - parseInt(this.props.navigatorStore.navigator.design.elements.indentation);
        }
      } else {
        if (this.props.navigatorStore.navigator.design.elements.indentation != undefined) {
          titleWidth = titleWidth - parseInt(this.props.navigatorStore.navigator.design.elements.indentation);
        }
      }
    }
    let heatMapColor = this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks ? this.props.navigatorStore.getHeatMapColorHSL(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks) : "";
    let heatMapBoxShadow = this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks ? `0px 0px 10px 3px ${Helper.lightenOrDarkenColor(this.props.navigatorStore.navigator.design.elementGroups.backgroundColor)} inset` : "";
    let element: JSX.Element;
    switch (this.props.type) {
      case "link":
        element = (
          <a
            data-interception={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "off" : "on"}
            target={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "_blank" : "_self"}
            onClick={() => this.onClick("Link")}
            href={!this.props.navigatorStore.isInEditMode && this.props.config.url ? this.props.config.url : undefined}
            className={[styles.elementLink, this.props.config?.url && !this.props.navigatorStore.isShowingAnalytics ? `IA_OnFocus ${styles.elementHover}` : ""].join(" ")}
          >
            <div
              style={{
                color: this.props.navigatorStore.navigator.design.elements.textColor,
                height: `${iconSize + 2}px`,
                backgroundColor: heatMapColor,
                boxShadow: heatMapBoxShadow
              }}
            >
              {this.props.config.icon != null &&
                <div
                  className={styles.elementLinkIcon}
                  style={{
                    width: iconSize,
                    height: iconSize,
                    padding: 0,
                    marginLeft: this.props.navigatorStore.navigator.design.elements.indentation != undefined ? `${this.props.navigatorStore.navigator.design.elements.indentation}px` : 0
                  }}
                >
                  <IAIcon
                    title={this.props.config.icon}
                    size={iconSize as number}
                    color={this.props.navigatorStore.navigator.design.elements.iconColor}
                  />
                </div>
              }
              <div
                className={styles.elementLinkText}
                style={{
                  width: titleWidth,
                  lineHeight: `${iconSize}px`,
                  height: `${iconSize + 2}px`,
                  marginLeft: this.props.navigatorStore.navigator.design.elements.indentation != undefined && (this.props.config.icon == null || this.props.config.icon === "") ? `${this.props.navigatorStore.navigator.design.elements.indentation}px` : 0
                }}
              >
                <IAConditionalTooltipWrapper
                  condition={this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks}
                  tooltipContent={
                    <div>
                      {this.props.navigatorStore.getClickTooltipLocalizationString(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}
                      ({this.props.navigatorStore.getPercentageOfClickComparedToAllClicks(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}%)
                    </div>
                  }
                  wrapper={(content) =>
                    <>{content}</>
                  }
                >
                  {this.props.config.text}
                </IAConditionalTooltipWrapper>
              </div>
            </div>
          </a>
        );
        break;
      case "video":
        element = (
          <div
            className={styles.elementVideo}
            style={{
              width: this.props.width,
              height: (this.props.width / 16) * 9,
              backgroundImage: this.props.config.url != undefined && Helper.isYouTubeUrl(this.props.config.url) ? `url(${Helper.getYouTubeThumbnailFromURL(this.props.config.url)}` : `url(${IMG_STREAM})`,
            }}
          >

            {this.props.navigatorStore.isInEditMode &&
              <div
                style={{
                  position: "absolute",
                  width: this.props.width,
                  height: (this.props.width / 16) * 9,
                  backgroundColor: "transparent"
                }}
                onClick={() => {
                  if (!(this.props.navigatorStore.isInEditMode && this.props.navigatorStore.checkedOut)) {
                    this.props.navigatorStore.toggleElementSettings(this.props.topItemIndex, this.props.columnIndex, this.props.elementGroupIndex, this.props.index);
                  }
                }}
              />
            }
            {!this.props.navigatorStore.droppableElementSpotsAreShowing && this.props.config.url &&
              <>
                {(this.props.config.url.indexOf(".mp4") === -1 && this.props.config.url.indexOf(".webm") === -1) ?
                  <iframe
                    width={this.props.width}
                    height={(this.props.width / 16) * 9}
                    src={Helper.isVimeoVideo(this.props.config.url) ? Helper.getVideoSrcFromEmbedCode(this.props.config.url) : this.props.config.url}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen={true}
                  />
                  :
                  <video
                    width={this.props.width}
                    height={(this.props.width / 16) * 9}
                    disablePictureInPicture
                    controlsList="nodownload noplaybackrate"
                    controls
                  >
                    <source src={this.props.config.url}></source>
                  </video>
                }
              </>
            }
          </div >
        );
        break;
      case "text":
        element = (
          <div
            onClick={() => this.onClick("Text")}
            className={[styles.elementText, this.props.config?.url ? "IA_OnFocus" : ""].join(" ")}
          >
            <IAReader
              id="IA_Reader"
              environment={this.props.navigatorStore.environment}
              token={this.props.navigatorStore.token}
              tenant={this.props.navigatorStore.tenant}
              content={this.props.config.content}
              style={{}}
              highlightColor={"orange"}
            />
          </div>
        );
        break;
      case "image":
        element = (
          <a
            data-interception={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "off" : "on"}
            target={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "_blank" : "_self"}
            onClick={() => this.onClick("ImageLink")}
            href={!this.props.navigatorStore.isInEditMode && this.props.config.url ? this.props.config.url : undefined}
            className={[styles.elementImage, this.props.config?.url ? "IA_OnFocus" : ""].join(" ")}
          >
            <IAConditionalTooltipWrapper
              condition={this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks && this.props.config.url != undefined}
              tooltipContent={
                <div>
                  {this.props.navigatorStore.getClickTooltipLocalizationString(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}
                  ({this.props.navigatorStore.getPercentageOfClickComparedToAllClicks(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}%)
                </div>
              }
              wrapper={(content) =>
                <div className={styles.elementImageContainer}>
                  {content}
                  <div className={styles.elementImageOverlay}
                    style={{
                      width: this.props.width,
                      backgroundImage: `radial-gradient(circle, ${heatMapColor} 40%, transparent 100%)`,
                    }}
                  />
                </div>
              }
            >
              <img
                src={this.props.config.imageUrl && this.props.config.imageUrl.indexOf("IntraActive-Navigator") != -1 ? Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.navigatorStore.environment), this.props.navigatorStore.tenant.replace(".sharepoint.com", ""), this.props.navigatorStore.token, this.props.config.imageUrl, this.props.navigatorStore.versions ? this.props.navigatorStore.versions[0].modifiedDate.toString().replace(/[^\d]/g, '') : "", undefined, undefined, false) : this.props.config.imageUrl}
                width={this.props.width}
              />
            </IAConditionalTooltipWrapper>
          </a>
        );
        break;
      default:
        break;
    }
    console.log(this.props.navigatorStore.hasChanged); // Forces Mobx to rerender
    const targetingInfo = this.props.navigatorStore.isInEditMode && this.getTargetingGroups("<br />");
    return (
      <div
        className={styles.element}
        style={{
          color: this.props.navigatorStore.navigator.design.elements.textColor,
          letterSpacing: this.props.navigatorStore.navigator.design.elements.letterSpacing,
          textTransform: this.props.navigatorStore.navigator.design.elements.textTransform,
          fontWeight: this.props.navigatorStore.navigator.design.elements.fontWeight,
          fontSize: this.props.navigatorStore.navigator.design.elements.fontSize,
          paddingTop: this.props.navigatorStore.droppableElementSpotsAreShowing ? 7 : 0,
          paddingBottom: this.props.navigatorStore.droppableElementSpotsAreShowing ? 5 : 0,
          cursor: !!this.props.config.url || this.props.navigatorStore.isInEditMode ? "pointer" : "default",
          backgroundColor: this.props.navigatorStore.isInEditMode && !this.props.navigatorStore.isShowingAnalytics ? Helper.lightenOrDarkenColor(this.props.navigatorStore.navigator.design.elementGroups.backgroundColor) : "transparent",
          marginBottom: this.props.navigatorStore.navigator.design.elements.padding ?? "25px",
          fontFamily: this.props.navigatorStore.fontSlots?.body?.fontFamily
        }}
        draggable={this.props.navigatorStore.droppableElementSpotsAreShowing}
        onDragStart={() => {
          this.props.navigatorStore.setDraggedElement(this.props.topItemIndex, this.props.columnIndex, this.props.elementGroupIndex, this.props.index);
        }}
        onDragEnd={() => {
          this.props.navigatorStore.draggedTopItemIndex = undefined;
          this.props.navigatorStore.draggedColumnIndex = undefined;
          this.props.navigatorStore.draggedElementGroupIndex = undefined;
          this.props.navigatorStore.draggedElementIndex = undefined;
        }}
      >
        {this.props.navigatorStore.isInEditMode && targetingInfo &&
          <NavigatorTargetingTooltip
            highlightColor={this.props.navigatorStore.highlightColor}
            targetingInfo={targetingInfo}
          />
        }
        {element}
      </div>
    )
  }
}
